module.exports = __webpack_public_path__ + "static/media/sdkPackageJson.d8428669.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/sdkPackageJson.png
// module id = 1536
// module chunks = 0